<template>
  <v-container pa-0>
    <v-progress-circular
      class="not-ready-wrapper"
      v-if="isInApiCall"
      :size="70"
      :width="7"
      color="#009688"
      indeterminate
    ></v-progress-circular>

    <div class="ready-wrapper" v-if="!isInApiCall">
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="receipt-master-container" v-if="receipt !== null">
        <!-- Receipt - Start -->

        <div class="slim-report report">
          
          <!-- Top banner - start -->
          <div class="top-banner-area">
            <table class="container-table">
              <tr>

                <td class="top-banner-lipi-logo">
                  <img src="../assets/lipi-logo.png" height="70" width="70">
                </td>

                <td class="top-banner-text">
                  Digital Receipt
                </td>

                <td class="top-banner-play-logo">
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://lipi.live/getlipi?ref=receipt"
                  >
                    <img src="../assets/google-play-badge.png" height="70" width="160">
                  </a>
                </td>

              </tr>
            </table>
            
          </div>
          <!-- Top banner - end -->

          <div class="main-content">
            <div class="header">
              <div class="name" style="color: #004D40; padding-bottom: 6px; padding-top: 10px;">{{ receipt.organization.name }}</div>
              <div>
                <div class="author-title" style="font-size: 14px;">Sales Receipt #{{ receipt.sales.salesNumber }}</div>
                <div>
                  Date: {{ receipt.sales.createdDatetimeStamp | date }}
                </div>
                <!-- <div>{{ app.organization.primaryBusinessAddress }}</div> -->
                <!-- <div>{{ app.organization.phone }}</div> -->
              </div>
              <div class="outlet-block">
                <div class="author-title">{{ receipt.outlet.name }}</div>
                <div>Phone: {{ receipt.outlet.phone }}</div>
              </div>
            </div>

            <!-- body - start -->
            <div class="body">
              <div v-if="receipt.sales.isDiscarded">
                <b>WARNING! This sale has been discarded.</b>
              </div>

              <div class="customer-area" style="padding-bottom: 6px;">
                <div v-if="receipt.sales.customerId">
                  <div>
                    <b>Customer: {{ receipt.customer.fullName }}</b>
                  </div>
                  <div v-if="receipt.customer.phone">
                    Phone: {{ receipt.customer.phone }}
                  </div>
                  <div v-if="receipt.customer.email">
                    Email: {{ receipt.customer.email }}
                  </div>
                </div>
              </div>

              <div
                class="receipt-text-1"
                v-if="receipt.outlet.outletReceiptText"
              >{{ receipt.outlet.outletReceiptText }}</div>

              <div
                class="receipt-text-1"
                v-if="receipt.organizationSettings.receiptText1"
              >{{ receipt.organizationSettings.receiptText1 }}</div>

              <table class="product-table">
                <tr class="tr-border-top-bottom">
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price {{ monetaryUnit }}</th>
                </tr>

                <tr v-for="product in receipt.sales.productList">
                  <td>
                    {{ product.productBlueprintName }}
                  </td>
                  <td class="quantitive-cell">{{ product.count }} {{ product.unit }}</td>
                  <td class="monetary-cell">{{ product.salePrice }}</td>
                </tr>

                <tr class="tr-border-top">
                  <th colspan="2" style="text-align: right;">Total Sale Price</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.totalAmount) }}</th>
                </tr>
                <tr>
                  <th colspan="2" style="text-align: right;">VAT (+)</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.vatAmount) }}</th>
                </tr>
                <tr>
                  <th colspan="2" style="text-align: right;">Discounted (-)</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.discountedAmount) }}</th>
                </tr>
                <tr v-if="receipt.sales.payment.roundedByAmount">
                  <th colspan="2" style="text-align: right;">Less (-)</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.roundedByAmount) }}</th>
                </tr>
                <tr class="tr-border-bottom">
                  <th colspan="2" style="text-align: right;">Service / Delivery Charge (+)</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.serviceChargeAmount) }}</th>
                </tr>
                <tr>
                  <th colspan="2" style="text-align: right;">Total Payable</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.totalBilled) }}</th>
                </tr>
                <tr>
                  <th colspan="2" style="text-align: right; color: #009688;">Total Paid</th>
                  <th class="monetary-cell" style="color: #009688;">{{ $round(receipt.sales.payment.totalPaidAmount) }}</th>
                </tr>
                <tr v-if="receipt.sales.payment.dueAmount">
                  <th colspan="2" style="text-align: right;">Due</th>
                  <th class="monetary-cell">{{ $round(receipt.sales.payment.dueAmount) }}</th>
                </tr>
                <tr class="tr-border-bottom">
                  <th colspan="3"></th>
                </tr>
              </table>

              <div class="section-header">
                <b>Payment ({{ monetaryUnit }})</b>
              </div>

              <table class="payment-table">
                <tr class="tr-border-top-bottom">
                  <!-- <th>Date</th> -->
                  <th>Method</th>
                  <th>Amount</th>
                  <th>Change</th>
                </tr>
                <tr v-for="payment of receipt.sales.payment.paymentList">
                  <!-- <td class="centered-cell">{{ payment.createdDatetimeStamp | date }}</td> -->
                  <!-- Payment Method: Following check is to ensure compatibility with old receipts -->
                  <td class="monetary-cell-center" style="text-transform: capitalize;" v-if="payment.paymentMethod">{{ payment.paymentMethod }}</td>
                  <td class="monetary-cell-center" style="text-transform: capitalize;" v-if="payment.paymentMethodDetails">{{ payment.paymentMethodDetails.name }}</td>
                  <td class="monetary-cell-center">{{ $round(payment.paidAmount) }}</td>
                  <td class="monetary-cell-center">{{ $round(payment.changeAmount) }}</td>
                </tr>
                <tr class="tr-border-bottom">
                  <th colspan="4"></th>
                </tr>
              </table>
            </div>
            <!-- body - end -->

            <div class="footer" style="padding-top: 6px;">
              <div class="footer-sold-by-slim">
                <div class="author-title">
                  Sold by: {{ receipt.soldByUser.fullName }}
                </div>
              </div>
            </div>

            <div
              class="receipt-text-2"
              v-if="receipt.organizationSettings.receiptText2"
            >{{ receipt.organizationSettings.receiptText2 }}</div>

          </div>

          <!-- Bottom banner - start -->
          <div class="bottom-banner-area">
            <div class="bottom-banner-text">

              See how
              <span style="font-weight: bold; color: #004D40;">Lipi</span>
              can help your business, visit
              <a href="https://lipi.live?ref=receipt" style="font-weight: bold; color: #004D40;">lipi.live</a>
            </div>
          </div>
          <!-- Bottom banner - end -->
        </div>

        <!-- Receipt - End -->
      </div>
    </div>
  </v-container>
</template>

<script>
import apis from "./../apis";
import { desanitize } from "./../sanitization";

export default {
  name: "receipt",

  async mounted() {
    this.isInApiCall = true;
    let res = await apis.callLiteGetReceiptApi({
      receiptToken: this.receiptToken
    });
    res = desanitize(res);
    this.isInApiCall = false;

    // console.log(res); // NOTE: Remove after making sure all unnecessary subproperties have been removed.
    if (res.hasError) {
      this.errorMessage = res.error.message;
      return;
    }

    let { sales, organization, outlet, soldByUser, customer, organizationSettings } = res;

    sales.payment.dueAmount = (Math.max(sales.payment.totalBilled - sales.payment.totalPaidAmount, 0));

    this.receipt = { sales, organization, outlet, soldByUser, customer, organizationSettings };
  },

  data() {
    return {
      isInApiCall: true,
      receiptToken: this.$route.params.receiptToken,
      receipt: null,
      errorMessage: null,
      monetaryUnit: "BDT"
    };
  },

  methods: {
    $round(a) {
      return Math.round(a);
    }
  }
};
</script>

<style scoped>
root {
  --primary-color: #009688;
  --primary-color-dark: #004D40;
  --primary-color-light: #B2DFDB;
}

.error-message {
  position: fixed;
  left: 0;
  top: 0;
  margin-top: calc(50vh - 70px / 2);
  /* margin-left: calc(50vw - 70px / 2); */
  text-align: center;
}

.not-ready-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  margin-top: calc(50vh - 70px / 2);
  margin-left: calc(50vw - 70px / 2);
}

/* ==================================================== */

/* slim - start */

.slim-report {
  /* padding: 4px; */
  font-size: 12px;
}

.top-banner-area .container-table {
  width: 100%;
  text-align: center;
}

.top-banner-lipi-logo {
  /* border: 1px solid red; */
  padding-top: 8px;
  padding-bottom: 6px;
    text-align: right;
}

.top-banner-text {
  /* border: 1px solid red; */
  font-size: 16px;
  text-align: left;
  padding-left: 6px;
}

.top-banner-play-logo {
  /* border: 1px solid red; */
  text-align: center;
  cursor: pointer;
}

.main-content {
  padding-left: 4px; 
  padding-right: 4px;
}

.slim-report .author-title {
  font-weight: bold;
}

.slim-report .header {
  padding-bottom: 4px;
  /* border-bottom: 1px solid black; */
}

.slim-report .header .name {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.slim-report .header .date {
  font-size: 10px;
  text-align: center;
}

.slim-report .header .outlet-block {
  margin-top: 8px;
}

.slim-report .body .item {
  margin-bottom: 8px;
  margin-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dotted rgb(131, 131, 131);
}

.slim-report .product-table,
.slim-report .payment-table {
  width: 100%;
  border-collapse: collapse;
}

/* table.product-table, */
.slim-report .product-table th,
.slim-report .product-table td,
.slim-report .payment-table th,
.slim-report .payment-table td {
  /* border: 1px solid black; */
}

.slim-report .product-table {
  /* margin-top: 18px; */
}

.slim-report .monetary-cell {
  text-align: right;
  padding-right: 4px;
}

.slim-report .monetary-cell-center {
  text-align: center;
  padding-right: 4px;
}

.slim-report .quantitive-cell {
  text-align: right;
  padding-right: 4px;
}

.slim-report .section-header {
  text-align: center;
  /* text-decoration: underline; */
  color: #004D40;
  margin-top: 18px;
  margin-bottom: 8px;
}

.slim-report .footer {
  margin-top: 8px;
  margin-bottom: 8px;
}

.slim-report .footer-sold-by {
  text-align: right;
}

.slim-report .customer-area {
  margin-top: 4px;
  margin-bottom: 8px;
}

.slim-report .centered-cell {
  text-align: center;
}

/* slim - end */

.receipt-text-1 {
  font-size: 10px;
  text-align: center;
  padding-bottom: 6px;
}

.receipt-text-2 {
  font-size: 10px;
  padding-bottom: 2px;
}

.tr-border-top-bottom {
  border-top: 1px solid #B2DFDB;
  border-bottom: 1px solid #B2DFDB;
}

.tr-border-top {
  border-top: 1px solid #B2DFDB;
}

.tr-border-bottom {
  border-bottom: 1px solid #B2DFDB;
}

.powered-by-footer {
  /* TODO: */
  visibility: hidden;
  font-size: 12px;
  text-align: center;
  font-style: italic;
  padding-bottom: 8px;
}

@media print {
  .filter-toggle-region,
  .filter-toggle-region paper-toggle-button,
  .filter-region {
    display: none;
  }

  .report {
    margin-top: 0;
  }

  .filter-toggle-region {
    text-align: right;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .ml-8 {
    margin-left: 8px;
  }
}

.report {
  background-color: white;
}

.top-banner-area {
  background-color: #B2DFDB;
  min-height: 80px;
}

.bottom-banner-area {
  background-color: #B2DFDB;
  min-height: 80px;
}

.bottom-banner-text {
  padding-top: 30px;
  font-size: 13px;
  text-align: center;
}
</style>
